import React,  { useRef } from "react";
import headerImage from "../../assets/header15.jpg";

import w14_01 from "../../assets/w14_01.jpg";
import w14_02 from "../../assets/w14_02.jpg";

import w14_07 from "../../assets/w14_07.jpg";
import w14_08 from "../../assets/w14_08.jpg";
import w14_09 from "../../assets/w14_09.jpg";
import w14_10 from "../../assets/w14_10.jpg";

import w14_13 from "../../assets/w14_13.jpg";
import w14_14 from "../../assets/w14_14.jpg";
import w14_15 from "../../assets/w14_15.jpg";
import w14_16 from "../../assets/w14_16.jpg";
import w14_17 from "../../assets/w14_17.jpg";
import w14_18 from "../../assets/w14_18.jpg";
import w14_19 from "../../assets/w14_19.jpg";
import w14_20 from "../../assets/w14_20.jpg";
import w14_21 from "../../assets/w14_21.jpg";
import w14_22 from "../../assets/w14_22.jpg";
import w14_23 from "../../assets/w14_23.jpg";
import w14_24 from "../../assets/w14_24.jpg";
import w14_25 from "../../assets/w14_25.jpg";
import w14_26 from "../../assets/w14_26.jpg";
import w14_27 from "../../assets/w14_27.jpg";
import w14_28 from "../../assets/w14_28.jpg";
import w14_29 from "../../assets/w14_29.jpg";
import w14_30 from "../../assets/w14_30.jpg";



const Assignment15 = () => {
  const appInventor = useRef(null);
  const UDP = useRef(null);
  const communication = useRef(null);
  const groupAssignment = useRef(null);
  const downloads = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 14: Interface and Application Programming</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">June 01, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}


        <button onClick={() => scrollToSection(appInventor)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
         App Inventor
        </button>
        <button onClick={() => scrollToSection(UDP)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          UDP Extension
        </button>
        <button onClick={() => scrollToSection(communication)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Communication
        </button>
        <button onClick={() => scrollToSection(downloads)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Downloads
        </button>
        <button onClick={() => scrollToSection(groupAssignment)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Group Assignment
        </button>

        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
  In this week’s assignment, the focus was on <strong>Interface and Application Programming</strong>. 
  As part of the individual assignment, I developed an application that interfaces with the microcontroller I used for my final project — allowing the user to control the device through a custom-built user interface. In the group assignment, we explored different programming environments and tools to evaluate their strengths and limitations for creating interactive applications.
  </p>



        <h2 className="text-2xl font-bold text-left mb-2">Creating a Simple Remote Control App for Manual Operation</h2>

<div className="text-gray-700 space-y-4 mt-6">


<p className="text-justify text-gray-700 mb-6">
 To create a basic app for manually controlling my final project, I used MIT App Inventor — a beginner-friendly platform that allows for quick and intuitive app development using a drag-and-drop interface.
</p>


        <p className="text-justify text-gray-700 mb-6">
        App Inventor is available online:
        <a 
          href="https://ai2.appinventor.mit.edu/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          https://ai2.appinventor.mit.edu/
        </a>.  </p>

        <p className="text-justify text-gray-700 mb-6">
        In order to use it, I had to login with a Google account. Once logged in, I created a new project and was able to design the app layout by dragging and dropping interface components like buttons and arrangements directly onto the smartphone preview screen.</p>
        
                {/* XYZ Section*/}
                <div ref={appInventor}></div>
        <h2 className="text-2xl font-bold text-left mb-2">Creating an App with App Inventor</h2>
        <p className="text-justify text-gray-700 mb-6">
        <p className="text-justify text-gray-700 mb-6">
        The first step is to create a new project. Settings such as the name of the project and the preferred theme can be made. I decided to chose a dark theme and called the App Robo_Controller. 
        </p>
        <img src={w14_07} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">
        The App Inventor interface appears next. In the center is an old emulated smartphone and on the left in the list are a handful of components that can be placed on the screen using drag and drop.
        </p>
        <img src={w14_08} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">
        First, I created five buttons and labeled them with arrow symbols and a stop icon. In the right view I have the names of the buttons for the internal program code.
        </p>
<img src={w14_09} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
Next, I experimented with the different arrangements, as I was aiming for a layout similar to that of a game controller. 
        </p>
<img src={w14_10} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
I tried to get closer to my goal with horizontal and vertical arrangements. When I was ready, I initially searched in vain for the function of a placeholder.
        </p>
<img src={w14_13} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
After a little research, I found out that you can achieve this by placing an appropriate arrangement where the space is to be kept free and setting the width to fill parent.
        </p>
<img src={w14_14} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
If you want to give the app its own image, which is displayed on the home screen, you can do this here.
        </p>

        
        <img src={w14_19} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
I was looking for a way to configure UDP communication in the table on the left column. Unfortunately, there were only other connectivity options. 
        </p>
<img src={w14_15} alt="" className="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">

        </p>
        <div ref={UDP}></div>
        <h2 className="text-2xl font-bold text-left mb-2">Sending Messages via UDP</h2>
        <p className="text-justify text-gray-700 mb-4">
  <strong>Adding UDP Communication</strong>
</p>
<p className="text-justify text-gray-700 mb-4">
  To control the ESP32 via WiFi, I needed UDP communication. App Inventor does not include a native UDP component, so I installed an external UDP extension.
</p>
<p className="text-justify text-gray-700 mb-4">
  Extensions can be found here:<br />
  <a href="https://puravidaapps.com/extensions.php" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
    https://puravidaapps.com/extensions.php
  </a>
</p>
<p className="text-justify text-gray-700 mb-4">
  I found the UDP extension from the community archive:<br />
  <a href="https://community.appinventor.mit.edu/t/all-rescued-extensions-from-thunkable-classic-community/56204/63" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
    Community UDP Extension Link
  </a>
</p>
<p className="text-justify text-gray-700 mb-4">
  <strong>Installing the Extension</strong>
</p>
<p className="text-justify text-gray-700 mb-4">
  To install it:
</p>
<ul className="list-disc pl-6 text-gray-700 mb-4 space-y-1">
  <li>I downloaded the <code>.aix</code> file.</li>
  <li>In App Inventor, I scrolled down to <em>Extension</em> in the left-hand sidebar.</li>
  <li>Clicked <em>Import Extension</em> and uploaded the file.</li>
</ul>
<img src={w14_16} alt="" className="my-4 mx-auto rounded shadow-md" />
<img src={w14_17} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-4">
  Once installed, I dragged the <code>ClientUDP</code> component into my project (non-visible components area).
</p>

<img src={w14_18} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
I switched to the block view and dragged a call ClientUDP1.Send block into the view. This should be triggered first when the app initializes Screen1. 
        </p>

<img src={w14_20} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
For this reason, I have nested the UDP block in the Screen1.Initialize block.
        </p>
<img src={w14_21} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
To fill the different variables of the UDP block with values, I had to create different types of built-in blocks. This was slightly counter-intuitive, as I had to create a text block for the IP and a math block for other numbers such as the port, for example.
        </p>
<img src={w14_22} alt="" className="my-4 mx-auto rounded shadow-md" />

<img src={w14_23} alt="" className="my-4 mx-auto rounded shadow-md" />

<img src={w14_24} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
After I had gradually filled the necessary elements of the UDP block, the app was ready for a first test. The aim of the first test was to send a “Hello World” via UDP from the cell phone to the ESP32 and output it on the console.
        </p>
        <p className="text-justify text-gray-700 mb-4">
  <strong>Building the .apk</strong>
</p>
        
<p className="text-justify text-gray-700 mb-6">
To test the app on my smartphone, I first had to create an .apk and then download and install it on my phone. Fortunately, App Inventor offers a very simple build process. You click on the “build” tab at the top and wait until the progress bar has run through. You can then download and install the app on your cell phone using a QR. I was really impressed with how easy and smooth the process was.
        </p>
        <img src={w14_27} alt="" className="my-4 mx-auto rounded shadow-md" />
        <img src={w14_29} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
And this is what the finished app looks like on my smartphone. Unfortunately, it's not as pretty as I would have liked for now, but at least it's functional.
        </p>
        <img src={w14_02} alt="" className="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">
At least the app can be rotated automatically without me having to change anything in the settings, so that there is at least a minimal bit of game controller feeling in landscape format.
        </p>
        <img src={w14_01} alt="" className="my-4 mx-auto rounded shadow-md" />

        <div ref={communication}></div>
        <h2 className="text-2xl font-bold text-left mb-2">Receiving Messages with the ESP32</h2>
      </p>
      <p className="text-justify text-gray-700 mb-6">
To receive the message sent by the app via UDP, I programmed the appropriate sketch for the ESP32. This sketch is very similar to the sketch I presented in the Network and Communication week.
        </p>
<img src={w14_25} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
First, the ESP32 connects to the WiFi and then starts receiving messages on port 4210. These are then parsed in the loop and a null operator is appended as the last character of a 255 character message.
        </p>
<img src={w14_26} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
This message is then displayed in the serial monitor and I was very happy that the “Hello World” sent was displayed there when I started the app on my smartphone. As always, the entire code for the ESP32 is available for download in the download section.
        </p>
        <p className="text-justify text-gray-700 mb-4">
  <strong>Implementation of the control commands</strong>
</p>
<p className="text-justify text-gray-700 mb-6">
        In order to transfer meaningful commands via the individual keys, I decided to create TouchDown and TouchUp blocks for the individual arrow keys. These have the advantage that they send something when the button is first pressed and something else when it is released. This allows the robot to be controlled more precisely than with simple .click blocks.
        </p>      
        <img src={w14_28} alt="" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">
        After I had finished configuring the blocks, I created the new app, uploaded it to the smartphone and was pleased to see that the correct commands were transferred.
        </p>
<img src={w14_30} alt="" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
Originally I wanted to use a slider to control it, but unfortunately I couldn't find it in App Inventor. With the help of the slider, I could have transmitted not only the directional impulse but also a value, for example from 0-100 for the intensity. I hope that I will find the opportunity to implement this in the future.
        </p>

        <div ref={downloads}></div>
      <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/RoboReceiver.ino"
    download
  >
    📎 Download RoboReceiver Code
  </a>
  <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Robo_Controller.apk"
    download
  >
    📎 Download Robo_Controller.apk
  </a>
        </div>
        <div ref={groupAssignment}></div>
        <h2 className="text-2xl font-bold text-left mb-2 mt-2">Group Assignment</h2>

  <p>In the world of embedded systems, the development doesn’t end with sensors, actuators, and microcontroller code. A crucial part of many projects is the interface between humans and machines - whether for control, configuration, or visualization. Choosing the right tool for creating such an interface depends on various technical constraints, target platform, project complexity, and prior experience.</p>
  <p>As part of our group assignment, I evaluated different ways of building an interface to communicate with a microcontroller - in my case, an <strong>ESP32S3</strong>.</p>

  <p className= "mt-2"> Personally, I have already created applications using:</p>
  <ul>
    <li><strong>Qt/QML</strong> for cross-platform desktop apps</li>
    <li><strong>React Native</strong> for mobile cross-platform apps</li>
    <li><strong>Android Studio</strong> for native Android development</li>
    <li><strong>MIT App Inventor</strong> for rapid prototyping</li>
    <li><strong>HTML/JavaScript</strong>-based web interfaces hosted directly by an ESP32 access point</li>
  </ul>
  <p>This allowed me to assess these tools not only functionally but also in terms of development effort, toolchain complexity, and target platform compatibility.</p>

  <h3 className="text-xl font-bold text-left mb-2"> Comparison Table</h3>
  <div class="overflow-x-auto">
    <table class="table-auto border border-gray-300 text-sm">
      <thead>
        <tr>
          <th class="border px-4 py-2">Tool / Framework</th>
          <th class="border px-4 py-2">Platforms</th>
          <th class="border px-4 py-2">Advantages</th>
          <th class="border px-4 py-2">Disadvantages</th>
          <th class="border px-4 py-2">Requirements</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="border px-4 py-2"><strong>Android Studio</strong></td>
          <td class="border px-4 py-2">Android</td>
          <td class="border px-4 py-2">Native performance, full system access, layout editor</td>
          <td class="border px-4 py-2">High complexity, Java/Kotlin required</td>
          <td class="border px-4 py-2">Android Studio IDE</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>React Native</strong></td>
          <td class="border px-4 py-2">Android, iOS</td>
          <td class="border px-4 py-2">Cross-platform, hot reload, modern UI</td>
          <td class="border px-4 py-2">Requires Node.js, limited native system access</td>
          <td class="border px-4 py-2">Node.js, Expo CLI</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>Flutter</strong></td>
          <td class="border px-4 py-2">Android, iOS, Web</td>
          <td class="border px-4 py-2">Excellent performance, declarative UI</td>
          <td class="border px-4 py-2">Requires Dart, heavy toolchain</td>
          <td class="border px-4 py-2">Flutter SDK, Dart</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>Swift/Xcode</strong></td>
          <td class="border px-4 py-2">iOS</td>
          <td class="border px-4 py-2">Native iOS development, modern language</td>
          <td class="border px-4 py-2">macOS only, limited cross-platform</td>
          <td class="border px-4 py-2">macOS, Xcode</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>MIT App Inventor</strong></td>
          <td class="border px-4 py-2">Android</td>
          <td class="border px-4 py-2">Rapid prototyping, visual blocks, quick UDP implementation</td>
          <td class="border px-4 py-2">Limited flexibility, not suited for production apps</td>
          <td class="border px-4 py-2">Web browser, Google account</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>HTML/JS (ESP Hosted)</strong></td>
          <td class="border px-4 py-2">All (browser)</td>
          <td class="border px-4 py-2">No installation, hosted directly on ESP32</td>
          <td class="border px-4 py-2">Limited mobile optimization, touch input tricky</td>
          <td class="border px-4 py-2">HTML/CSS/JS</td>
        </tr>
        <tr>
          <td class="border px-4 py-2"><strong>Qt/QML</strong></td>
          <td class="border px-4 py-2">Desktop, Android</td>
          <td class="border px-4 py-2">High performance, native apps, flexible UI</td>
          <td class="border px-4 py-2">High learning curve, complex deployment</td>
          <td class="border px-4 py-2">Qt SDK, C++</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h3 className="text-xl font-bold text-left mb-2 mt-2">Simulation & Debugging</h3>
  <p>Modern frameworks like Flutter and React Native support features like Hot Reload or simulators for testing without a physical device. One example is Expo Go. Android Studio also includes a robust emulator.</p>

  <h3 className="text-xl font-bold text-left mb-2 mt-2">Networking Differences</h3>
 
  <p className="text-justify text-gray-700 mb-4">
    When building an interface to communicate with a microcontroller like the ESP32, it's important to consider how each platform handles network communication. Some key aspects include:
  </p>
  <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-1">
    <li>Supported protocols: Does the framework support UDP, TCP, HTTP, or WebSocket?</li>
    <li>Access to local networks: Can the app connect to devices within the same Wi-Fi network (LAN)?</li>
    <li>Permission handling: Are special user permissions or firewall rules needed?</li>
    <li>Ease of implementation: How complex is it to send and receive data?</li>
    <li>Responsiveness: Does the interface remain smooth while handling background communication?</li>
  </ul>

  <h3 className="text-xl font-semibold mt-6 mb-2">Comparison Example of UDP</h3>
  <div className="space-y-4 text-gray-700">
    <div>
      <p className="font-semibold">Android Studio (Java/Kotlin):</p>
      <p>
        Offers full low-level control via native networking libraries like <code className="bg-gray-200 px-1 rounded">DatagramSocket</code> for UDP.
        Great for performance-critical or custom protocols, but more verbose.
      </p>
    </div>

    <div>
      <p className="font-semibold">MIT App Inventor:</p>
      <p>
        Extremely quick to set up using the “UDP Client” extension — perfect for prototyping. Less flexibility for advanced networking logic but ideal for students or non-programmers.
      </p>
    </div>

    <div>
      <p className="font-semibold">React Native:</p>
      <p>
        Requires third-party modules such as <a href="https://www.npmjs.com/package/react-native-udp" className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">react-native-udp</a>.
        Cross-platform, but setup is more involved, and iOS network permissions can be tricky.
      </p>
    </div>
  </div>


  <h3 className="text-xl font-bold text-left mb-2 mt-2"> Conclusion - What I have learned</h3>
  <ul>
    <li> The use case decides: App Inventor is completely sufficient for simple prototypes and controls. For production-ready or complex apps, I would choose React Native or Android Studio.</li>
    <li>UDP works across platforms, but the integration varies significantly in complexity.</li>
    <li>I have developed a deeper understanding of app toolchains, network architecture and the importance of making the right choice between low-code, hybrid and native solutions.</li>
  </ul>
</div>



  );
};

export default Assignment15;
